// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/soc-frontend/" + chunkId + "." + {"4":"f5d880a5","22":"78f43001","49":"1dadc55f","81":"f7b17093","223":"4633c073","325":"adcc298d","682":"e1d8e920","905":"24a8fc7e","967":"a0494842"}[chunkId] + ".chunk.js";
};